export const QUALIFICATION_CODE = {
  GENDER: 211,
  AGE: 212,
  INCOME: 213,
  RACE: 214,
  EMPLOYMENT: 215,
  EDUCATION: 216,
  CHILDREN_LEGACY: 218,
  DEVICE: 219,
  ZIPCODE: 229,
  CHILD_AGE_GENDER: 232,
  FSA: 303,
} as const;

export const FILE_UPLOAD_LOCATION_QUALIFICATION_CODES: ReadonlySet<number> =
  new Set([QUALIFICATION_CODE.ZIPCODE, QUALIFICATION_CODE.FSA]);

export const ZIPCODE_DISABLED_COUNTRY_CODES: ReadonlySet<string> = new Set([
  'KZ',
  'VN',
]);

export const LOCATION_UPLOAD_ROW_LIMIT = 25001;

export const FSA_COUNTRY_CODE = 'CA';

export const LOCATION_UPLOAD_ACCEPTED_EXTENSION = '.csv';

export const DEFAULT_AGE_QUOTA_CRITERIA = {
  NAME: 'Age',
  MIN: 18,
  MAX: 99,
  UNITS: 311,
} as const;

export const QUALIFICATIONS_RENDER_TYPE = {
  MULTIPUNCH_DROPDOWN: 1,
  FILE_UPLOAD: 2,
  SEARCH: 3,
  RANGE: 4,
  MULTIPUNCH_LIST: 5,
} as const;

// Quota category discriminant. A 'layered' quota targets a single condition; a 'grouped'
// quota combines several conditions of the same qualification into one target.
export const QUALIFICATIONS_CATEGORIES = {
  LAYERED: 'layered',
  GROUPED: 'grouped',
} as const;

export const NOT_TO_BE_GROUPED_QUALIFICATIONS: Set<number> = new Set([
  211, 212, 213, 218, 229, 232, 303,
]);
